import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

import { Container, Header, Grid, Button, Loader, Progress, Icon, Label, Segment, Form, DropdownProps, InputProps } from "semantic-ui-react";

import AliancaMenu from "../../components/Menu";
import Footer from "../../components/Footer";

import { format } from "date-fns";

import TableApp, { ITableAppRender } from "../../components/TableApp";

import errors from "../../Utils/ExtractErrors";
import AgentProductivityRepository, { IProductivityMonth, IProductivityParams } from "../../Repositories/AgentProductivityRepository";
import { GetUser } from "../../services/auth";
import CustomLoader from "../../components/CustomLoader";


const AgentProductivityMonth: React.FC = () => {

    const date = new Date();
    const actualMonth = date.toLocaleString('default', { month: 'long' });
    const [list, setList] = useState<IProductivityMonth[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [state, setState] = useState<IProductivityParams>({ dataInicial: "", dataFinal: "" });
    const totalQtd = list.reduce((a, b) => a + b.quantidade, 0);

    const { role } = GetUser();


    let valueMeta = 0;
    var metaDay = date.getDate();

    if (metaDay < 4) {
        valueMeta = 5;
    }
    else if (metaDay < 7) {
        valueMeta = 10;
    }
    else if (metaDay < 10) {
        valueMeta = 15;
    }
    else if (metaDay < 13) {
        valueMeta = 20;
    }
    else if (metaDay < 16) {
        valueMeta = 25;
    }
    else if (metaDay < 19) {
        valueMeta = 30;
    }
    else if (metaDay < 22) {
        valueMeta = 35;
    }
    else if (metaDay < 25) {
        valueMeta = 40;
    }
    else if (metaDay < 28) {
        valueMeta = 45;
    }
    else {
        valueMeta = 50;
    }



    const load = async () => {

        setLoading(true);
        try {

            const response = await AgentProductivityRepository.PartialMonth({
                dataInicial: state.dataInicial,
                dataFinal: state.dataFinal
            });

            setList(response);
        } catch (err) {
            if (err.response.status === 401) {
                window.location.href = "/";
            }

            const error = errors.getAllErrors(err.response.data);

            if (error !== undefined)
                toast(error, { position: "top-center", type: "error" });
        }
        setLoading(false);
    };

    const onChange = (event: React.SyntheticEvent<HTMLElement, Event>, data: InputProps) => {
        const { name, value } = data;
        setState(state => ({ ...state, [name]: value }));
    }

    const tableRender: ITableAppRender[] = [
        {
            header: "Quantidade",
            content: (x: IProductivityMonth) => x.quantidade,
            textAlign: "center",
            width: 2
        },
        {
            header: "Representante",
            content: (x: IProductivityMonth) => x.representante,
            textAlign: "left",
            width: 14
        },
    ];

    const renderMetaGs = (
        <>
            <Grid.Row>
                <Icon name="flag outline" color="blue" />
                {" "}Meta estimada para o dia {format(new Date(), "dd/MM/yyyy")}
                <Progress indicating value={valueMeta} total={50} active progress='ratio'>
                </Progress>
            </Grid.Row>
            <Grid.Row>
                <Icon name="play" color="pink" />
                {" "}Meta Atual
                <Progress indicating value={totalQtd} total={50} active progress='ratio'>
                </Progress>
            </Grid.Row>
        </>
    )

    return (
        <>
            <AliancaMenu />
            <Container className="app-margin">
                {loading ? <Segment><CustomLoader /></Segment> :
                    <Grid columns="equal">
                        <Grid.Row>
                            <Grid.Column>
                                <Header size="huge" content={`PRODUTIVIDADE`} icon="chart line" />
                            </Grid.Column>
                        </Grid.Row>
                        {
                            role === "GerenteS" &&
                            <Grid.Row>
                                <Grid.Column width="16">
                                    <Segment color="purple" raised>
                                        <Label ribbon content="Meta: 50 Kits" size="large" color="green" />
                                        {renderMetaGs}
                                    </Segment>
                                </Grid.Column>
                            </Grid.Row>
                        }
                        <Grid.Row>
                            <Grid.Column>
                                <Form>
                                    <Form.Group widths="equal">
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                label="Data Inicial"
                                                labelPosition="left"
                                                name="dataInicial"
                                                type="date"
                                                value={state.dataInicial}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                        <Form.Field>
                                            <Form.Input
                                                fluid
                                                label="Data Final"
                                                labelPosition="left"
                                                name="dataFinal"
                                                type="date"
                                                value={state.dataFinal}
                                                onChange={onChange}
                                            />
                                        </Form.Field>
                                    </Form.Group>
                                </Form>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column>
                                <Button
                                    disabled={
                                        (state.dataInicial !== "" && state.dataFinal !== "") ? false : true
                                    }
                                    fluid
                                    icon="search"
                                    color="pink"
                                    content="Atualizar"
                                    onClick={load}
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Column>
                            <Grid.Row>
                                <TableApp
                                    render={tableRender}
                                    list={list}
                                    loading={loading}
                                />
                            </Grid.Row>
                        </Grid.Column>
                    </Grid>
                }
            </Container>
            <Footer />
        </>
    );
};

export default AgentProductivityMonth;
